import { Button } from 'antd';
import { useNavigate } from 'react-router';

import { signOut } from '@/entities/session';
import LogoutIcon from '@/shared/assets/icons/logout.svg?react';
import { images } from '@/shared/assets/images/images';
import { useAppDispatch } from '@/shared/model/storeHooks';

import s from '@/shared/ui/AuthForm.module.css';

export const LoginHeader = ({ withLogout = false }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(signOut());
    navigate('/login');
  };

  return (
    <div className={s.header}>
      <img className={s.logo} src={images.logo} alt="" />
      {withLogout && (
        <div className={s.headerAction}>
          <Button
            type="link"
            danger
            icon={<LogoutIcon />}
            onClick={handleLogout}
          >
            Log out
          </Button>
        </div>
      )}
    </div>
  );
};
